import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Layout, Menu, Breadcrumb } from 'antd';

import Chat from './components/ws-chatbot';

const { Header, Content, Footer } = Layout;

function App() {
  return (
    <Layout className="layout">
      <Content style={{ padding: '0 0px' }}>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<p>Homepage</p>} />
            <Route path="/:CHAT_UID" element={<Chat />} />
          </Routes>
        </Router>
      </Content>
    </Layout>
  );
}

export default App;